module.exports = __webpack_public_path__ + "static/media/156.55af7511.svg";